<template lang="html">
	<vddl-draggable class="panel__body--item group"
					:draggable="item"
					:index="index"
					:disable-if="disable"
					:selected="selectedEvent"
					:wrapper="list"
					:type="type"
					:moved="handleMovedList"
					v-bind:class="{'selected': selectedItem === item}">
		<div class="panel padding" v-if="item.type === 'CONTAINER'">
			<div class="panel__heading">
				<h3><span class="fa fa-ellipsis-v drag"></span> {{$t(item.title) || item.title}}</h3>
				<input type="hidden" class="text-edit" v-model="item.title">
				<span class="fa fa-pencil edit" @click="toggleInputEdit('group', $event)"></span>
			</div>
			<vddl-list class="panel__body"
					   :list="item.attributes"
					   :disable-if="disable"
					   :drop="handleDropList"
					   :allowed-types="['list', 'container', 'itemList']"
					   :external-sources="true">
				<list v-for="(col, index) in item.attributes"
					  :key="col.id"
					  :item="col"
					  :list="item.attributes"
					  :index="index"
					  :selected="selectedEvent"
					  :selected-item="selectedItem"
					  :disable-if="disable"
					  :disable="disable"
					  :localization="localization"
					  :item-structure="itemStructure"
					  :dropzones="dropzones"
					  :update-dropzones="updateDropzones"
					  @clear-input-container="clearInputContainer"
					  :toggle-input-edit="toggleInputEdit"
				>
				</list>
			</vddl-list>
		</div>
		<p class="attribute" v-else>
			<span class="fa fa-ellipsis-v drag"></span>
			<template v-if="!itemStructure[item.title]">
				{{ item.title }}
			</template>
			<template v-else>
				{{( $t(itemStructure[item.title].title) || itemStructure[item.title].title) }}
			</template>
			<span class="fa" :class="locked ? 'fa-lock attribute_editable_lock': 'fa-unlock attribute_editable_unlock'" :title="locked ? $t('edit.locked'): $t('edit.unlocked')" @click="lockedAttributeEdit(item)"></span>
			<br/>
			<span>{{'{' + item.title + '}'}}</span>
		</p>
	</vddl-draggable>
</template>

<script>

export default {
	name: 'list',
	data () {
		return {
			type: 'list',
			locked: false
		}
	},
	props: [
		'item',
		'list',
		'index',
		'selected',
		'selectedItem',
		'disable',
		'currItem',
		'diff',
		'localization',
		'itemStructure',
		'dropzones',
		'updateDropzones',
		'toggleInputEdit'
	],
	methods: {
		selectedEvent (item) {
			if (typeof (this.selected) === 'function') {
				this.selected(item)
			}
		},
		handleDropList (data) {
			console.log(':v-list: drop 2')
			console.log(data)
			const { index, list, item } = data
			if (!this.disable) {
				item.id = Math.random()
				this.updateDropzones(this.dropzones, item)
				list.splice(index, 0, item)
				this.clearInputContainer()
			}
		},
		handleMovedList (item) {
			console.log(':v-draggable: moved 2')
			console.log(item)
			const { index, list } = item
			if (!this.disable) {

			}
		},
		clearInputContainer () {
			this.$emit('clear-input-container')
		},
		lockedAttributeEdit (item) {
			item.locked = !item.locked
			this.updateDropzones(this.dropzones, item)
			this.locked = item.locked
		}
	},
	created () {
		this.locked = this.item.locked ? this.item.locked : false
	}
}
</script>

<style lang="scss">
.attribute {
	position: relative;
	&:hover &_editable_unlock {
		display: block;
	}

	&:hover &_editable_unlock_label {
		display: block;
	}

	%editable_shared {
		position: absolute;
		top: 10px;
		right: 0;
		padding: 5px;
		border-radius: 50%;
		background-color: #f5f5f5;
		&:hover {
			cursor: pointer;
		}
	}

	%editable_shared_label {
		position: absolute;
		top: 2px;
		right: 25px;
	}

	&_editable_unlock {
		display: none;
		@extend %editable_shared
	}

	&_editable_lock {
		@extend %editable_shared
	}

	&_editable_unlock_label {
		display: none;
		@extend %editable_shared_label
	}

	&_editable_lock_label {
		@extend %editable_shared_label
	}
}
</style>
